import { createFileRoute } from '@tanstack/react-router';

import {
  auctionBidsQueryOptions,
  AuctionDetailPage,
  auctionQueryOptions,
} from '@/features/auctions';

export const Route = createFileRoute('/_authed/_active/s/$storeId/auctions/$auctionId')({
  staticData: { tours: ['auctions.detail'] },
  loader: async ({ context, params }) => {
    const [auction] = await Promise.all([
      context.queryClient.query({
        ...auctionQueryOptions(params.storeId, params.auctionId),
        staleTime: 'static',
      }),
      context.queryClient
        .query({
          ...auctionBidsQueryOptions(params.storeId, params.auctionId, {
            includeRetracted: true,
            limit: 50,
          }),
          staleTime: 'static',
        })
        .catch(() => undefined),
    ]);
    return { crumb: auction.lot.title };
  },
  component: AuctionDetailPage,
});
